import React from 'react';

import { AuxiliaryResources } from '@ariksa/inventory-core';
import { Categories, Resources } from '@ariksa/inventory-core/api';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { formatTooltip } from 'components/DataDisplay';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { Route53HostedZoneIcon } from 'components/Icons';
import { selectCloudPostureOverview } from 'containers/Dashboard/CloudPostureOverview/selectors';
import { selectDashboard } from 'containers/Dashboard/selectors';
import { SummaryCard } from 'containers/Dashboard/utils/SummaryCard';

import { colorOpacity, customTheme } from '../../../../../theme';

export const Domains: React.FC = () => {
  const { infrastructurePostureSummary, domainsCount } = useSelector(
    selectDashboard,
  );
  const { data, isLoading } = infrastructurePostureSummary;
  const navigate = useNavigate();
  const { subDomains } = useSelector(selectCloudPostureOverview);

  return (
    <SummaryCard
      label="Domains"
      icon={<Route53HostedZoneIcon />}
      change={{
        isLoading: false,
        first: domainsCount.data.previous_count ?? 0,
        last: domainsCount.data.current_count ?? 0,
        percentChange: domainsCount.data.percentage_change ?? 0,
      }}
      cloudProviders={data?.items?.['ProvidersByLabel']?.['Domains']}
      count={data?.items?.['Network']?.['Domains']}
      isLoading={isLoading}
      onClick={() =>
        navigate(
          '/inventory/cloud?resource_category=' +
            Categories.Network +
            '_' +
            Resources.Dns,
        )
      }
      info={{
        message:
          formatNumber(
            subDomains.data?.[AuxiliaryResources.Route53SubDomain] || 0,
          ) + ' sub-domains',
        bg: colorOpacity(customTheme.colors.primary, 0.3),
        isLoading: subDomains.isLoading,
      }}
      showPercentChange={true}
      labelTooltip={formatTooltip({
        header: 'Domains',
        content:
          'DNS related resources such as domains, sub-domains for your SaaS',
        width: 48,
      })}
    />
  );
};
